<template>
    <div>
        <a-form layout="inline" :form="dataForm" @submit="getDataList" class="p-20">
            <a-form-item label="客户" v-if="showCustomer">
                <a-select v-model="dataForm.customer_id" placeholder="请输入客户姓名搜索" style="width: 200px" allowClear
                    show-search :filter-option="false" :not-found-content="customerFetching ? undefined : null"
                    @search="handleCustomerSearch" @focus="getCustomerList">
                    <a-spin v-if="customerFetching" slot="notFoundContent" size="small" />
                    <a-select-option v-for="item in customerList" :key="item.customer_id" :value="item.customer_id">
                        {{ item.customer_name }} - {{ item.customer_phone }}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item label="行程规划名称">
                <a-input v-model="dataForm.title" placeholder="规划名称搜索" />
            </a-form-item>
            <a-form-item label="状态">
                <a-select v-model="dataForm.status" style="width: 100px;">
                    <a-select-option value="1">在用</a-select-option>
                    <a-select-option value="2">已删除</a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
            </a-form-item>
            <a-form-item v-permission="['admin:haibao:update']" v-if="showAddButton">
                <a-button type="primary" @click="addOrUpdateHandle('')" :loading="loading">新增行程规划</a-button>
            </a-form-item>
        </a-form>
        <a-table :columns="columns" :data-source="dataList" :pagination="false" rowKey="id"
            :loading="dataListLoading || loading" :scroll="{ x: 1160 }">
            <template slot="confirm_text" slot-scope="text, row">
                <a-tag
                    :color="row.confirm_type == 1 ? '' : row.confirm_type == 2 ? 'green' : row.confirm_type == 3 ? 'red' : ''">{{
                        text }}</a-tag>
            </template>
            <template slot="userinfo" slot-scope="text, row">
                <a-tag v-if="!row.userinfo" color="red">新建心愿单,尽快处理</a-tag>
                <a-tag v-else>{{ row.userinfo.real_name }}</a-tag>
            </template>
            <template slot="editBtn" slot-scope="text, row">
                <a-sapce :size="0">
                    <a-button type="link" @click="setmodel(row.haibaoid, row.model == 1 ? 0 : 1)"
                        v-permission="['admin:haibao:setmodel']">
                        {{ row.model == 1 ? '取消设为模板' : '设为模板' }}
                    </a-button>
                    <a-button type="link" @click="addOrUpdateHandle(row.haibaoid, true)"
                        v-permission="['admin:haibao:detail']">
                        查看
                    </a-button>
                    <a-button type="link" @click="addOrUpdateHandle(row.haibaoid)"
                        v-permission="['admin:haibao:update']" v-if="row.status == 1">
                        编辑
                    </a-button>
                    <a-button type="link" @click="deleteHandle(row.haibaoid)" v-permission="['admin:haibao:delete']"
                        style="color: red" v-if="row.status == 1">
                        删除
                    </a-button>
                </a-sapce>
            </template>
        </a-table>
        <a-pagination class="mt-20 float-right" show-size-changer :current="page" :total="total"
            :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange"
            @change="pageCurrentChangeHandle" />
    </div>
</template>

<script>
import viewModule from "@/mixins/view-module";
export default {
    mixins: [viewModule],
    props: {
        customer_id: String,
        showCustomer: {
            type: Boolean,
            default: false
        },
        showAddButton: {
            type: Boolean,
            default: true
        },
    },
    watch: {
        customer_id(newValue) {
            this.dataForm.customer_id = newValue
            this.getDataList()
        }
    },
    data() {
        return {
            loading: false,
            customerFetching: false,
            customerList: [],
            mixinViewModuleOptions: {
                getDataListURL: "/admin/haibao/page",
                deleteURL: '/admin/haibao/delete'
            },
            dataForm: {
                title: "",
                status: '1',
                customer_id: this.customer_id,
            },
            columns: [
                {
                    title: '客户姓名',
                    dataIndex: 'customerinfo.customer_name',
                    width: 150
                },
                {
                    title: "行程名称",
                    dataIndex: "title",
                    width: 200
                },
                {
                    title: "行程状态",
                    dataIndex: "confirm_text",
                    width: 120,
                    scopedSlots: { customRender: "confirm_text" },
                },
                {
                    title: '创建人',
                    dataIndex: 'userinfo',
                    width: 140,
                    scopedSlots: { customRender: "userinfo" },
                },
                {
                    title: "创建时间",
                    dataIndex: "create_time",
                    width: 200
                },
                {
                    title: "操作",
                    align: 'center',
                    fixed: 'right',
                    scopedSlots: { customRender: "editBtn" },
                    width: 350
                },
            ],
        };
    },
    methods: {
        addOrUpdateHandle(haibaoid, readonly = false) {
            if (!haibaoid) {
                this.loading = true
                this.$http({
                    url: '/admin/haibao/create',
                    method: 'post',
                    data: {
                        customer_id: this.customer_id
                    }
                }).then(res => {
                    this.$router.push({ path: '/haibao', query: { haibaoid: res.data.haibaoid } })
                }).finally(() => this.loading = false)
            } else {
                this.$router.push({ path: '/haibao', query: { haibaoid: haibaoid, rn: readonly ? 1 : 0 } })
            }
            this.$emit("changeNewCustomerid", this.customer_id)
            // this.$refs.addOrUpdate.init(haibaoid, this.customer_id);
        },
        setmodel(haibaoid, model) {
            this.$http({
                url: '/admin/haibao/setmodel',
                method: 'post',
                data: {
                    haibaoid,
                    model
                }
            }).then((res) => {
                this.getDataList()
                this.$message.success(res.message)
            })
        },
        // 客户搜索（带防抖）
        handleCustomerSearch(value) {
            // 清除之前的定时器
            if (this.customerSearchTimer) {
                clearTimeout(this.customerSearchTimer);
            }

            // 设置新的定时器，500ms 后执行搜索
            this.customerSearchTimer = setTimeout(() => {
                this.getCustomerList(value);
            }, 500);
        },
        // 获取客户列表
        getCustomerList(searchKeyword = '') {
            // 如果没有搜索关键词且列表已有数据，则不重复请求
            if (!searchKeyword && this.customerList.length > 0) return;

            this.customerFetching = true;
            this.$http({
                url: "/admin/customer/allCustomerSelect",
                method: "get",
                params: {
                    page: 1,
                    limit: 20,
                    customer_name: searchKeyword, // 模糊搜索客户姓名
                },
            }).then((res) => {
                this.customerList = res.data.result || [];
            }).finally(() => {
                this.customerFetching = false;
            });
        },
    },
};
</script>

<style></style>